import { type UpdateHistoryResponseDto, V2EventCreateRequestDtoCategory, V2NoticeReadResponseDtoCategory } from "@everon-it/api-client/contents-gw";
import { type NoticeCommonContentsOptionType } from "@pages/NoticeCreate/Data";
import { CommonElementType } from "@utils/DynamicComponentUtils";
import { type CommonCreateBodyKeyType, type CommonDataType } from "src/types/common";

export type NoticeDetailInitValuesType = {
    category: V2NoticeReadResponseDtoCategory;
    title: string;
    isVisible: boolean;
    isPinned: boolean;
    displayStartAt: string;
    displayEndAt: string;
    contentCategory: V2EventCreateRequestDtoCategory;
    content: string;
    reason: string;
    updateHistory: UpdateHistoryResponseDto[];
};

export const NoticeDetailData: CommonDataType<CommonCreateBodyKeyType, NoticeDetailInitValuesType, NoticeCommonContentsOptionType> = {
    createBodyKey: ["category", "title", "isVisible", "isPinned", "displayStartAt", "displayEndAt", "content", "reason"],
    formInitialValues: {
        category: V2NoticeReadResponseDtoCategory.GENERAL,
        title: "",
        isVisible: false,
        isPinned: false,
        displayStartAt: "",
        displayEndAt: "",
        contentCategory: V2EventCreateRequestDtoCategory.CONTENT,
        content: "",
        reason: "",
        updateHistory: [],
    },
    contentsOption: [
        {
            label: "게시 유형",
            name: "category",
            type: CommonElementType.RADIO,
            options: [
                { label: "공지사항(충전서비스)", value: V2NoticeReadResponseDtoCategory.GENERAL },
                { label: "투자정보", value: V2NoticeReadResponseDtoCategory.IR },
            ],
        },
        {
            label: "게시 기간",
            type: CommonElementType.DATE_RANGE_PICKER,
            name: "displayStartAt",
            secondName: "displayEndAt",
            placeholder: "날짜를 입력해주세요",
            secondPlaceholder: "날짜를 입력해주세요",
        },
        {
            label: "노출 상태",
            name: "isVisible",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "상단 고정 여부",
            name: "isPinned",
            type: CommonElementType.TOGGLE,
        },
        {
            label: "제목",
            name: "title",
            type: CommonElementType.INPUT,
            placeholder: "제목을 입력해주세요",
        },
    ],
};
